export interface CustomFieldControlType {
    ID: number;
    Description: string;
   }

   export enum CustomFieldControlTypeEnum {
    Textbox = 1,
    Image = 2,
    Buttons = 3,
    RadioButtons = 4,
    MultiLineTextbox = 5,
    Date = 6,
    Checkbox = 7,
    Dropdown = 8,
    Time = 9,
    DateTime = 10,
    Text = 11,
    Component = 12 // TODO
}